module.exports = __webpack_public_path__ + "img/strategy.fff1d705.png";